//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import stopInfoContent from './stopInfoContent.vue';
import stopDirectionContent from './stopDirectionContent.vue';
import pastStopContent from './pastStopContent.vue';
import connectedStopConstant from '../../../constants/connected-stop';

export default {
  name: 'StopInformation',
  components: {
    stopInfoContent,
    stopDirectionContent,
    pastStopContent,
  },
  computed: {
    ...mapGetters({ stopDetailChange: 'getStopDetail' }),
    isCompletedStop() {
      return this.stopDetailChange.is_completed;
    },
    showPastStopTab() {
      return this.checkConnectedStopStatus() && !this.isCompletedStop;
    },
  },
  data() {
    return {
      componentType: 'stop-info-content',
      stopInfoActive: true,
      stopInstructionsActive: false,
      pastStopActive: false,
      dynamicCols: '6 text-align',
      stopInfoText: 'Stop Info',
      stopInstructionText: 'Stop Instructions',
      pastInfoText: 'Past Stop',
    };
  },
  created() {
    this.isConnectedStop();
  },
  methods: {
    stopDetail(val) {
      this.resetActiveClass();
      switch (val) {
        case 'stop-info':
          this.componentType = 'stop-info-content';
          this.stopInfoActive = true;
          break;
        case 'stop-direction':
          this.componentType = 'stop-direction-content';
          this.stopInstructionsActive = true;
          break;
        case 'past-stop':
          this.componentType = 'past-stop-content';
          this.pastStopActive = true;
          break;
        default:
          this.componentType = 'stop-info-content';
          this.stopInfoActive = true;
      }
    },
    isConnectedStop() {
      if (this.checkConnectedStopStatus() && !this.isCompletedStop) {
        this.dynamicCols = 'auto text-align';
      }
    },
    resetActiveClass() {
      this.stopInfoActive = false;
      this.stopInstructionsActive = false;
      this.pastStopActive = false;
    },
    openInventoryList() {
      this.$emit('openInventoryList');
    },
    checkConnectedStopStatus() {
      if (this.stopDetailChange.connected_status) {
        if (this.stopDetailChange.connected_status === connectedStopConstant.status.NOT_CONNECTED) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
};
